export default __webpack_public_path__ + "static/posx-f71a2cb6540fc597b95e91cd6c2e1a07.jpg";